import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GET_LANDING_IMAGE, GET_LST_LANDING_CASE_STUDY_DATA, INFORMATION_LIST, LIST_NEW_NOTIFICATION } from 'manager/http-constants';
import { forkJoin } from 'rxjs';
import { DICID_NUMBER, NOTICE_TYPES } from 'src/app/shared/constant/constant';
import { LoadingState } from 'src/app/shared/html-parts/loading/loading-state';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { PlatformComponent } from '../platform.component';
import { LoginService } from 'src/app/shared/service/login.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss', '../platform.component.scss']
})

export class LandingComponent extends PlatformComponent implements OnInit {
  isShowContact = false;
  landingImages: string[];
  listNotice: object[];
  listCaseStudy: any[] = [];
  // お知らせ情報リスト
  noticeDataList: object[] = new Array();
  // システムに関するお知らせ情報リスト
  platformEventDataList: object[] = new Array();
  listClass;
  constructor(
    public route: ActivatedRoute,
    private router: Router,
    public loadingState: LoadingState,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loginService: LoginService
  ) {
    super(route, commonService, dbOperationService, loadingState, loginService);
  }

  ngOnInit(): void {
    this.loadingState.loadStart();
    // 辞書値リストを取得
    this.getSpecCodeList(DICID_NUMBER.GROUP_TYPE);
    forkJoin([
      this.getLandingImagesList(),
      this.getNoticeDataList(NOTICE_TYPES.MEMBER_NOTICE),
      this.getNoticeDataList(NOTICE_TYPES.SYSTEM_NOTICE),
      this.getCaseStudyList()
    ]).subscribe((dataList) => {
      this.listClass = this.getDicList(1);
      this.listNotice = this.noticeDataList.concat(
        this.platformEventDataList
      ).sort((a: any, b: any) => this.compareNotice(a, b));
      this.loadingState.loadEnd();
    });
  }

  getLandingImagesList() {
    return new Promise<any>((resolve) => {
      this.dbOperationService
        .getNoTemplateData(GET_LANDING_IMAGE, null, false)
        .subscribe((response) => {
          if (!this.commonService.checkNoneResponse(response)) {
            this.landingImages = response.body;
          }
          resolve(response);
        });
    });
  }
  /**
   * お知らせ情報リスト取得
   * @param information_kbn お知らせ区分(1:お知らせ 2:PF主催イベント)
   */
  private getNoticeDataList(information_kbn: string) {
    return new Promise<any>((resolve) => {
      // お知らせ一覧を取得
      this.dbOperationService
        .getNoTemplateData(
          INFORMATION_LIST,
          { information_kbn: information_kbn },
          true
        ).subscribe((response) => {
          // お知らせ情報
          if ('1' == information_kbn) {
            if (!this.commonService.checkNoneResponse(response)) {
              // お知らせ一覧を格納
              this.noticeDataList = response.body;
            } else {
              this.noticeDataList = new Array();
            }
          }

          // システムに関するお知らせ情報
          if ('2' == information_kbn) {
            if (!this.commonService.checkNoneResponse(response)) {
              // システムに関するお知らせ一覧を格納
              this.platformEventDataList = response.body;
            } else {
              this.platformEventDataList = new Array();
            }
          }
          resolve(response);
        });
    });
  }
  private getCaseStudyList() {
    return new Promise<any>((resolve) => {
      // お知らせ一覧を取得
      this.dbOperationService
        .getNoTemplateData(
          GET_LST_LANDING_CASE_STUDY_DATA,
          false
        ).subscribe((response) => {

          if (!this.commonService.checkNoneResponse(response)) {
            // システムに関するお知らせ一覧を格納
            this.listCaseStudy = response.body;
          } else {
            this.listCaseStudy = new Array();
          }
          resolve(response);
        });
    });
  }
  moveContact() {
    this.router.navigate(["pages/platform/contact"]);
  }
  getManualSchool() {
    window.open("")
  }
  getManualSupport() {
    window.open("")
  }

  public compareNotice(a: any, b: any) {
    let publishDateResult = new Date(b.publishe_start).getTime() - new Date(a.publishe_start).getTime();
    if (publishDateResult != 0) {
      return publishDateResult;
    } else {
      return new Date(b.create_datetime).getTime() - new Date(a.create_datetime).getTime();
    }
  }
  move(path: string, params?: object) {
    if (params) {
      this.router.navigate([path], { queryParams: params });
    } else {
      this.router.navigate([path]);
    }
  }

  isClamped(el: HTMLElement): boolean {
      if (!el) return false;
      const computedStyle = window.getComputedStyle(el);
      const maxLines = 2;
      let lineHeight = parseFloat(computedStyle.lineHeight);
      if (!lineHeight) {
        lineHeight = parseFloat(computedStyle.fontSize) * 1.2;
      }
      const clampHeight = lineHeight * maxLines;
      return el.scrollHeight > clampHeight;
    }
}
